module.exports = "/_next/static/images/twitter-card-996f113b262b1a656e51c7aed6d948d5.jpg";